export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553286433/AileReisi/ailereisikapak.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553286439/AileReisi/420-PM.png',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553286440/AileReisi/ailereisi002.png'
];